// 登录页
<template>
  <div class="login">
    <!-- 粒子效果 -->
    <vue-particles
      class="lizi"
      color="#BACAD9"
      :particleOpacity="0.8"
      :particlesNumber="30"
      shapeType="circle"
      :particleSize="4"
      linesColor="#BACAD9"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.8"
      :linesDistance="200"
      :moveSpeed="2"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="repulse"
    ></vue-particles>
  
    <!-- 公司logo及名称 -->
    <div class="companyInfo">
      <img src="../assets/logo.png" alt />
      <!-- <p>百博&图零官网后台管理系统</p> -->
    </div>
    <div class="main_box">
      <div class="formBox">
        <!--用户登录-->
        <el-form :model="ruleFormLogin" label-position="left" label-width="0px" class="loginForm">
          <h3 class="title">百博&图零官网后台管理系统</h3>
          <el-form-item prop="user_id">
            <el-input
              prefix-icon="el-icon-user"
              type="text"
              v-model="ruleFormLogin.user_id"
              auto-complete="off"
              placeholder="请输入账号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              prefix-icon="el-icon-lock"
              type="password"
              v-model="ruleFormLogin.password"
              placeholder="请输入密码"
              @keyup.enter.native="userLandBt"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="submit_btn"
              round
              @click="userLandBt"
              :loading="logining"
            >登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="copyright">Copyright 杭州百博电子商务有限公司 allrights reserved ICP备案：浙ICP备16040228号-2</div>
  </div>
</template>
<script>
// 引入工具类
import utils from "@/utils";

// 引入api
// import api from "@/api/index";
export default {
  name: "login",
  data() {
    return {
      logining: false, // 确定按键--加载效果
      // 用户登录
      ruleFormLogin: {
        user_id: "",
        password: ""
      }
    };
  },
  created() {},
  methods: {
    /**
     * 操作函数
     */
    // 用户登录
    userLandBt: function() {
      if (!this.ruleFormLogin.user_id || this.ruleFormLogin.user_id === "") {
        utils.notificationInfo("提示", "请输入用户名", "warning");
        return;
      }
      if (!this.ruleFormLogin.password || this.ruleFormLogin.password === "") {
        utils.notificationInfo("提示", "请输入密码", "warning");
        return;
      }
      
      if(this.ruleFormLogin.user_id == "baibo" && this.ruleFormLogin.password == "baibo666"){
        utils.notificationInfo("提示", "登录成功", "success");
        this.$router.push({
          path: "/"
        }).catch(()=>{})
        window.sessionStorage.setItem('sign','wosuibianxiede')
      }else{
        utils.notificationInfo("提示", "用户名或密码错误", "warning");
      }
    },

    /**
     * api
     */
    // 登录
    loginFunc(paramObj) {
      // api.login(paramObj)
      //   .then(
      //     function(response) {
      //       // console.log(response)
      //       this.logining = false;
      //       // 用户数据存储
      //       utils.sessionSetStore("user_id", paramObj.user_id);
      //       utils.sessionSetStore('token', response.data.Token);
      //       utils.sessionSetStore('dayLeft', response.data.day);
      //       utils.sessionSetStore("nickname", paramObj.user_id);
      //       utils.sessionSetStore("cycle",response.data.cycle);
      //       // 获取品牌列表
      //       this.brandListFunc()
      //     }.bind(this)
      //   )
      //   .catch(function(err) {
      //     // console.log(err);
      //     if (err.code == 1000) {
      //       utils.notificationInfo("提示", "账号剩余时间不足,请充值！" , "error");
      //     } else {
      //       utils.notificationInfo("错误提示", '用户名或密码错误，请重新登录', "error");
      //     }
      //   });
    },
    
  }
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  position: relative;
  height: 100%;
  overflow: hidden;
  .lizi {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: url("../assets/login_bg2.jpg") center;
    background-size: 100% 100%;
    z-index: 1;
  }
  .companyInfo {
    position: absolute;
    left: 50px;
    top: 50px;
    z-index: 2;
    img {
      float: left;
      height: 80px;
    }
    p {
      float: left;
      font-size: 28px;
      line-height: 80px;
      color: #666;
    }
  }
  .main_box {
    position: absolute;
    width: 400px;
    left: 50%;
    top: 50%;
    border: 1px solid #ddd;
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
    padding: 10px 60px 20px;
    transform: translate(-50%, -50%);
    // top: 100px;
    // transform: translateX(-50%);
    z-index: 2;

    .formBox {
      .loginForm {
      }
      .title {
        font-size: 20px;
        padding: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
        color: #4d4b4b;
      }
      .submit_btn {
        width: 100%;
      }
    }
  }
  .copyright {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    z-index: 2;
    color: #666;
  }
}
</style>
